import React, { Component }  from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import DiscoveredDomains from './discovered-domains';

import { openCollectionTab } from '../../dashboard/actions/collection-action-creators';
import { discoveredDomainHierarchyParamSelector } from './discovered-domains-selectors';

export class DiscoveredDomainsContainer extends Component{
    componentDidMount(){
        const {
            match: { params: { collectionId } },
            openCollectionTab
        } = this.props;

        // the container uses dynamic collection tab navigation structure, so this needs to
        // match the child canvas in collection-config
        const tabMeta = {
            id: 'discovered-domains',
            name: 'Discovered Domains',
            url: `/${collectionId}/discovered-domains`
        };

        openCollectionTab( this.props, tabMeta );
    }

    render(){
        const {
            domainHierarchyParam,
            match,
        } = this.props;

        if( match.params.collectionId !== 'system' ){
            return <Redirect to={{ pathname: `/collections/system` }} />;
        }

        return (
            <DiscoveredDomains
                match={match}
                selectedDomainFilter={domainHierarchyParam}
            />
        );
    }
};

/* istanbul ignore next */
const mapStateToProps = ( state, props ) => {
    return {
        domainHierarchyParam: discoveredDomainHierarchyParamSelector( props ),
    };
};

const mapDispatchToProps = {
    openCollectionTab
};

DiscoveredDomainsContainer.propTypes = {
    domainHierarchyParam: PropTypes.string,
    match: PropTypes.shape( {
        params: PropTypes.shape( {
            collectionId: PropTypes.string
        } ),
        url: PropTypes.string,
    } ),
    openCollectionTab: PropTypes.func.isRequired,
};

export default connect( mapStateToProps, mapDispatchToProps )( DiscoveredDomainsContainer );
